export default __webpack_public_path__ + "static/media/location--12.244fd260.jpg";